import { render, staticRenderFns } from "./relaImport.vue?vue&type=template&id=1ace6fb2&scoped=true&"
import script from "./relaImport.vue?vue&type=script&lang=js&"
export * from "./relaImport.vue?vue&type=script&lang=js&"
import style0 from "./relaImport.vue?vue&type=style&index=0&id=1ace6fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ace6fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ace6fb2')) {
      api.createRecord('1ace6fb2', component.options)
    } else {
      api.reload('1ace6fb2', component.options)
    }
    module.hot.accept("./relaImport.vue?vue&type=template&id=1ace6fb2&scoped=true&", function () {
      api.rerender('1ace6fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/WuyeZiyuanManager/house/relaImport.vue"
export default component.exports